import { useQuery } from "@tanstack/react-query";
import getConfig from "@/utils/getConfig";

export type TimeFilter = "day" | "week" | "month" | "year" | "all";

interface PlayStatsResponse {
    xpOverall: number;
    xpGaming: number;
    xpOther: number;
    timePlayed: number;
    gamesPlayed: number;
    timeFilter: string;
    startDate: string;
    endDate: string;
}

export const useGetPlayStats = (
    fullToken: string | null | undefined,
    timeFilter: TimeFilter = "all",
) => {
    return useQuery<PlayStatsResponse>({
        queryKey: ["playStats", fullToken, timeFilter],
        queryFn: async () => {
            if (!fullToken) {
                throw new Error("No authentication token");
            }

            const config = getConfig();
            const response = await fetch(
                `${config.basePath}/devourplay/play-stats?timeFilter=${timeFilter}`,
                {
                    headers: {
                        Authorization: fullToken,
                        "Content-Type": "application/json",
                    },
                },
            );

            if (!response.ok) {
                throw new Error(`Failed to fetch play stats: ${response.statusText}`);
            }

            return response.json();
        },
        enabled: !!fullToken,
        staleTime: 1000 * 60 * 5, // 5 minutes
        refetchOnWindowFocus: false,
    });
};